module.exports = __webpack_public_path__ + "img/telegram_chat_news.60b33ce1.png";